const capitalise = (s: string) => {
  if (typeof s !== "string") return "";
  return s.charAt(0).toUpperCase() + s.slice(1);
};

const ariaInvalidCheck = (fieldName: string, errors: any, validationFailures: any, prefix?: string) => {
  const capitalisedFieldName = capitalise(fieldName);
  const validationFieldName = prefix ? `${prefix}.${capitalisedFieldName}` : capitalisedFieldName;

  let inValid = false;
  if (errors && Object.prototype.hasOwnProperty.call(errors, fieldName)) {
    inValid = true;
  } else if (validationFailures && validationFailures[validationFieldName]) {
    inValid = true;
  }

  return inValid;
};

export {
  capitalise,
  ariaInvalidCheck
};
